import { buildSteps, buildFields } from '@app/utils/form'

// Views
import ClaimForm from '@views/ClaimForm'
import { FormField, FormStep } from '@views/Form'

const config: Page.Config = {
  title: 'Submission Form',
  dataset: ['submission'],
  view: ClaimForm,
  content: {
    wizard: (config: any, data: any, actions: any) => {
      const fields = buildFields(
        {
          fields: config.campaignConsumerFields,
          universe: config.campaignUniverse,
          prizes: config.campaignPrizes,
          currency: config.campaignCurrency,
          country: config.campaignCountry,
        },
        FormField
      )

      return {
        onSubmit: data.submit,
        steps: buildSteps(fields, FormStep).map((x: any) => ({
          ...x,
          props: {
            ...x.props,
            submitting: data.submitting,
          },
        })),
        fields,
      }
    },
  },
}

export default config
